// extracted by mini-css-extract-plugin
export default {"tableButtons":"TableButtons_tableButtons__b2pQL","tableButtons__img":"TableButtons_tableButtons__img__vkj8n","tableButtons__button":"TableButtons_tableButtons__button__mpYcn"};